import { action } from '@ember/object';
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { captureException } from '@sentry/ember';
import { DateTime } from 'scaleflow/utils/date-time';

export default class MoleculesApproachPlanListItemComponent extends Component {
  @service store;
  @service router;
  @service('organisation') orgService;
  @service('beta-toggle') betaService;
  @service notifications;
  @service intl;

  dropDownOptions = [
    {
      title: 'Delete Week',
      icon: 'delete',
      menuFunction: () => this.deleteWeek(),
    },
  ];

  // Committing a record whose delete already went through issues another
  // DELETE, and the second one is rejected against a cache entry the first
  // one's success already cleared — which throws inside WarpDrive.
  get weekIsGone() {
    const week = this.args.week;
    return Boolean(week?.isDeleted || week?.isDestroyed || week?.isDestroying);
  }

  @action
  async deleteWeek() {
    // The dropdown stays open and clickable for the whole round trip, so a
    // second click lands here while the first DELETE is still in flight.
    if (this.weekIsGone || this.args.week?.isSaving) return;

    const initiative = this.store.peekRecord(
      'initiative',
      this.args.initiativeId,
    );

    try {
      await this.args.week.destroyRecord();
      await initiative?.reorderWeeks();
    } catch (error) {
      captureException(error);
      this.notifications.toggleShowNotification(
        this.intl.t('_initiatives.week-delete-failed'),
      );
    }
  }

  get weekDate() {
    const start_date = this.router.currentRoute.attributes.startDate;
    if (!start_date) return '';
    const date = DateTime.from(start_date);
    const current_week_date = date.add(this.args.index_position - 1, 'weeks');
    return `W${current_week_date.format('WW, Do MMM')}`;
  }

  @action
  async onBlur() {
    // The title field is torn down along with the row when the week is
    // deleted, so a blur can land after the delete has already been issued.
    if (this.weekIsGone) return;

    try {
      await this.args.week.save();
    } catch (error) {
      captureException(error);
    }
  }
}
